var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticClass: "pa-4",
      attrs: { role: "region", "aria-labelledby": "checkout-complete-heading" },
    },
    [
      _c(
        "h2",
        { staticClass: "sr-only", attrs: { id: "checkout-complete-heading" } },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$t("components.checkout.completedHeading") ||
                  "Checkout completed"
              ) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _vm.hasOrder
        ? _c(
            "v-alert",
            {
              attrs: {
                type: "success",
                color: "success",
                icon: "check_circle",
                "aria-live": "assertive",
                border: "left",
                dense: "",
              },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.$t("components.checkout.completed", {
                      points: _vm.points,
                    })
                  ) +
                  "\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasOrder
        ? _c(
            "v-alert",
            {
              attrs: {
                type: "info",
                color: "info",
                icon: "info",
                "aria-live": "polite",
                border: "left",
                dense: "",
              },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("components.checkout.noteCompleted")) +
                  "\n  "
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }